module.exports = __webpack_public_path__ + "static/media/GODITO.a2154534.png";